export const sources = {
	webp: "__VITE_ASSET__2$LtLFQdS6IeO$uJxLxRJQ__ 600w, __VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__ 1000w"
};
export const img = {
	src: "__VITE_ASSET__U2YZxvNlcnuoWcGKwa9Wsw__",
	w: 1000,
	h: 667
};
export default {
	sources: sources,
	img: img
};
